import React, { useEffect, useState, useRef } from "react";
import CodeList from "../../lib/CodeList";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const codeList = new CodeList();

const _mClassName = "CitySelect";

let continents = [];
let countries = [];
let cities = [];
let scrollTop = window.scrollY || document.documentElement.scrollTop;

export default function CitySelect(props) {
  const { callback = () => {}, isShow, setIsShow, isAir = false } = props;
  const { t } = useTranslation();
  const [searchCodeList, setSearchCodeList] = useState([]);
  const [searchContinent, setSearchContinent] = useState("");
  const [searchCountry, setSearchCountry] = useState("");
  const [searchCity, setSearchCity] = useState(null);
  const [minWidth, setMinWidth] = useState(530);
  const itemRefs = useRef({});

  useEffect(() => {
    if (!isAir) {
      if (codeList.codeCountryFullName.length === 0) {
        socket.addLocalEventListener(
          MsgIDList.EVENT_INIT_CODE_COUNTRY_FULL_NAME,
          _mClassName,
          (oldV, newV) => {
            setSearchCodeList(newV);
          }
        );
      } else {
        setSearchCodeList(codeList.codeCountryFullName);
      }
    } else {
      if (codeList.codeAirCountryFullName.length === 0) {
        socket.addLocalEventListener(
          MsgIDList.EVENT_INIT_CODE_COUNTRY_FULL_NAME_AIR,
          _mClassName,
          (oldV, newV) => {
            setSearchCodeList(newV);
          }
        );
      } else {
        setSearchCodeList(codeList.codeAirCountryFullName);
      }
    }
    resizeLayout();
    window.addEventListener("resize", resizeLayout);
    return () => {
      window.removeEventListener("resize", resizeLayout);
    };
  }, []);

  function resizeLayout() {
    if (window.innerWidth > 991) {
      setMinWidth(530);
    } else {
      setMinWidth("100%");
    }
  }

  useEffect(() => {
    if (searchCodeList.length > 0) {
      continents = searchCodeList.filter(
        (item, index, self) =>
          index ===
          self.findIndex((t) => t.Continent && t.Continent === item.Continent)
      );
      countries = searchCodeList.filter(
        (item, index, self) =>
          index ===
          self.findIndex((t) => t.Country && t.Country === item.Country)
      );
      cities = searchCodeList.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.City && t.City === item.City)
      );
    }
  }, [searchCodeList]);

  useEffect(() => {
    function closeModal(event) {
      const targets = document.getElementsByClassName("city-select");
      let isContains = false;
      for (let i = 0; i < targets.length; i++) {
        if (targets[i].contains(event.target)) {
          isContains = true;
        }
      }
      if (!isContains) {
        setIsShow(false);
      }
    }

    if (isShow) {
      scrollTop = window.scrollY || document.documentElement.scrollTop;
      document.addEventListener("mousedown", closeModal);
      document.documentElement.style.scrollBehavior = "auto";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollTop}px`;
      document.body.style.width = "100%";
    } else {
      document.removeEventListener("mousedown", closeModal);
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollTop); // 이전 위치로 이동
      document.documentElement.style.scrollBehavior = "smooth";
    }
  }, [isShow]);

  useEffect(() => {
    if (searchContinent && searchCountry && searchCity) {
      const continentTarget = itemRefs.current[searchCity.Continent];
      if (continentTarget) {
        continentTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      const countryTarget = itemRefs.current[searchCity.Country];
      if (countryTarget) {
        countryTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      const cityTarget = itemRefs.current[searchCity.City];
      if (cityTarget) {
        cityTarget.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [searchContinent, searchCountry, searchCity]);

  function enterSearchText(text) {
    const findCity = cities.find(
      (c) =>
        text &&
        (c.CityName.indexOf(text) > -1 ||
          c.CityName_EN.indexOf(text.toUpperCase()) > -1)
    );
    if (findCity) {
      setSearchContinent(findCity.Continent);
      setSearchCountry(findCity.Country);
    } else {
      setSearchContinent("");
      setSearchCountry("");
    }
    setSearchCity(findCity);
  }

  return (
    <>
      <div
        className="city-select position-relative w-100"
        style={{ zIndex: 99 }}
      >
        <div
          className="position-absolute rounded overflow-hidden shadow-sm border mt-2 w-100 fade-in-down"
          style={{
            minWidth: minWidth,
            background: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            // borderRadius: "12px",
            // padding: "20px",
            color: "#fff",
          }}
        >
          <div>
            <div className="d-flex flex-row text-dark font-size-09 w-100">
              <div
                id="continents"
                className="flex-fill overflow-scroll border-right"
                style={{ height: 200, width: "33.3333%", overflowY: "scroll" }}
              >
                <div style={{ minHeight: 201 }}>
                  {continents.map((c) => {
                    return (
                      <div
                        key={c.Continent}
                        ref={(e) => (itemRefs.current[c.Continent] = e)}
                        className={`py-2 px-2 border-bottom cursor_pointer cursor_pointer_bg_light cursor_pointer_fw_bold ${
                          (searchCity &&
                            searchCity.Continent === c.Continent) ||
                          searchContinent === c.Continent
                            ? "bg-freiscop-10 font-weight-bold"
                            : ""
                        }`}
                        onClick={() => {
                          setSearchContinent(c.Continent);
                          setSearchCountry("");
                        }}
                      >
                        {c.ContinentName}
                        <p className="font-size-08">{c.ContinentName_EN}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                id="countries"
                className="flex-fill overflow-scroll border-right"
                style={{ height: 200, width: "33.3333%", overflowY: "scroll" }}
              >
                <div style={{ minHeight: 201 }}>
                  {searchContinent === "" && (
                    <div
                      className="w-100 px-3 d-flex flex-row justify-content-center align-items-center"
                      style={{ height: 200 }}
                    >
                      {t("citySelect.selectContinent")}
                    </div>
                  )}
                  {searchContinent !== "" &&
                    countries
                      .filter((c) => c.Continent === searchContinent)
                      .map((c) => {
                        return (
                          <div
                            key={c.Country}
                            className={`py-2 px-2 border-bottom cursor_pointer cursor_pointer_bg_light cursor_pointer_fw_bold ${
                              (searchCity &&
                                searchCity.Country === c.Country) ||
                              searchCountry === c.Country
                                ? "bg-freiscop-10 font-weight-bold"
                                : ""
                            }`}
                            onClick={() => setSearchCountry(c.Country)}
                            ref={(e) => (itemRefs.current[c.Country] = e)}
                          >
                            {c.CountryName}
                            <p className="font-size-08">{c.CountryName_EN}</p>
                          </div>
                        );
                      })}
                </div>
              </div>
              <div
                id="cities"
                className="flex-fill overflow-scroll"
                style={{ height: 200, width: "33.3333%", overflowY: "scroll" }}
              >
                <div style={{ minHeight: 201 }}>
                  {searchCountry === "" && (
                    <div
                      className="w-100 px-3 d-flex flex-row justify-content-center align-items-center"
                      style={{ height: 200 }}
                    >
                      {t("citySelect.selectCountry")}
                    </div>
                  )}
                  {searchCountry !== "" &&
                    cities
                      .filter((c) => c.Country === searchCountry)
                      .map((c) => {
                        return (
                          <div
                            key={c.City}
                            className={`py-2 px-2 border-bottom cursor_pointer cursor_pointer_bg_light cursor_pointer_fw_bold ${
                              searchCity && searchCity.City === c.City
                                ? "bg-freiscop-10 font-weight-bold"
                                : ""
                            }`}
                            onClick={() => callback(c)}
                            ref={(e) => (itemRefs.current[c.City] = e)}
                          >
                            {c.CityName}
                            <p className="font-size-08">{c.CityName_EN}</p>
                          </div>
                        );
                      })}
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between p-1 m-1 rounded bg-light position-relative">
              <input
                type="text"
                className="flex-fill border-0 bg-transparent text-dark"
                placeholder={t("citySelect.enterSearchText")}
                onChange={(e) => enterSearchText(e.target.value)}
                onKeyPress={(e) => {
                  if (e.charCode === 13 && searchCity) {
                    callback(searchCity);
                  }
                }}
              />
              <span
                className="position-absolute text-secondary h6 mb-0"
                style={{ right: 10 }}
              >
                <i className="fa-solid fa-magnifying-glass" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
